import { useConnect } from 'sb-redux-hook'


const useIsRecurly = () => {
  const { provider } = useConnect({
    provider: 'models.me.paymentProvider',
  }, [])

  return provider === 'RECURLY'
}


export default useIsRecurly
